import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signInUser } from "../Components/Utility/Auth";
import { Group } from "../models/group.model";

const BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:5001/api/";
const user = signInUser();

export const GroupApi = createApi({
  reducerPath: "GroupApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Group"],
  endpoints: (builder) => ({
    groups: builder.query<Group[], any>({
      query: (arg) => {
        const id =
          (typeof arg === "object" && arg?.aamarId) ||
          arg ||
          signInUser()?.aamarId;
        return `/group/${id}`;
      },
      providesTags: ["Group"],
    }),
    group: builder.query<Group, string>({
      query: (_id) => `/group/group/${_id}`,
      providesTags: ["Group"],
    }),
    addGroup: builder.mutation<Group, Group>({
      query: (newGroup) => ({
        url: "/group", // Matches the `/group` route in your backend
        method: "POST", // Matches the POST method in your backend
        body: newGroup, // Sends the `req.body` as expected by your backend
      }),
      invalidatesTags: ["Group"], // Updates the cache when a new group is added
    }),
    addImportGroup: builder.mutation<{}, Group>({
      query: (group) => ({
        url: "/group/import",
        method: "POST",
        body: group,
      }),
      invalidatesTags: ["Group"],
    }),
    groupList: builder.query<Group[], any>({
      query: (aamarId) => `/group/list/${aamarId}`,
      providesTags: ["Group"],
    }),
    
    groupCount: builder.query<Group[], any>({
      query: ({ aamarId }) => `/group/count/${aamarId}`,
      providesTags: ["Group"],
    }),
    groupById: builder.query<Group, string>({
      query: (_id) => `/group/${_id}`,
      providesTags: ["Group"],
    }),
    groupPagination: builder.query<Group, any>({
      query: ({ page, size, aamarId, q }) =>
        `/group/all/${page}/${size}/${aamarId}?q=${q}`,
      // query: ({page, size, q}) => `/Customer`,
      providesTags: ["Group"],
    }),
    updateGroup: builder.mutation<void, Group>({
      query: ({ _id, ...rest }) => {
        return {
          url: `/group/${_id}`, // Correctly use the _id in the URL
          method: "PUT",
          body: rest, // The rest of the data to update
        };
      },
      invalidatesTags: ["Group"],
    }),

    groupDw: builder.query<Group, string>({
      query: () => `/group/groupDw/${user?.aamarId}/${user?.warehouse}`,
      providesTags: ["Group"],
    }),

    deleteGroup: builder.mutation<void, string>({
      query: (id) => ({
        url: `/group/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Group"],
    }),
  }),
});

export const {
  useGroupsQuery,
  useGroupQuery,
  useGroupListQuery,
  useGroupDwQuery,
  useGroupByIdQuery,
  useGroupPaginationQuery,
  useGroupCountQuery,
  useAddGroupMutation,
  useAddImportGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
} = GroupApi;

export default GroupApi;
